import type { TerminalImportLogDto } from "../../types/TerminalImportLogDto";
import type { TerminalImportLogEntity } from "../../types/TerminalImportLogEntity";

export const TerminalImportLogDtoToEntity = ({ ...rest }: Readonly<TerminalImportLogDto>): TerminalImportLogEntity => {
    return { ...rest };
};
